import BottomSheet from "@/shared/ui/BottomSheet";
import PrimaryButton from "@/shared/ui/PrimaryButton";
import lockIcon from "@/assets/icons/common/lock.png";
import { useTapInteraction } from "@/shared/ui/pressable";
import styles from "./Credit4uPasswordExpirySheet.module.scss";

export type Credit4uPasswordExpirySheetProps = {
  isOpen: boolean;
  /** [변경하기] — 신용정보원 비밀번호 갱신 화면으로 이동 */
  onChangePassword: () => void;
  /** [취소하기] — 닫기 */
  onCancel: () => void;
};

type SecondaryButtonProps = {
  onClick: () => void;
  children: string;
};

const SecondaryButton = ({ onClick, children }: SecondaryButtonProps) => {
  const { isPressed, ref, pressHandlers } =
    useTapInteraction<HTMLButtonElement>();
  return (
    <button
      ref={ref}
      type="button"
      className={`${styles.ctaSecondary} ${isPressed ? styles.pressed : ""}`.trim()}
      onClick={onClick}
      {...pressHandlers}
    >
      {children}
    </button>
  );
};

// 신용정보원(credit4u) 비밀번호 90일 만료 안내 — Figma 2190:11180.
// NotRegisteredSheet 와 동일한 floating BottomSheet 패턴
// (배경 dim Fade In + sheet 하단→상단 slide up).
// 사용자 명시 선택(버튼) 전용 sheet — 배경 탭·native back 은 흔들림(닫힘 불가, BottomSheet 공통 규칙), ESC·drag 비활성.
const Credit4uPasswordExpirySheet = ({
  isOpen,
  onChangePassword,
  onCancel,
}: Credit4uPasswordExpirySheetProps) => (
  <BottomSheet
    isOpen={isOpen}
    // 외부 닫힘 트리거(ESC 등)가 모두 비활성이라 실제로 호출되지 않는 no-op (NotRegisteredSheet 동일).
    onClose={() => {}}
    presentation="partial"
    placementStyle="floating"
    showCloseButton={false}
    closeOnBackdrop={false}
    closeOnEsc={false}
    draggable={false}
    showDragHandle={false}
    backdropOpacity={0.6}
    contentClassName={styles.sheetContent}
  >
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="credit4u-password-expiry-title"
      className={styles.sheetBody}
    >
      <img
        src={lockIcon}
        alt=""
        className={styles.icon}
        width="50"
        height="50"
      />
      <div className={styles.textGroup}>
        <h2 id="credit4u-password-expiry-title" className={styles.title}>
          비밀번호 변경이 필요해요
        </h2>
        <p className={styles.desc}>
          {"보험 정보를 새로 불러오려면\n기존 비밀번호를 다시 설정해야 해요"}
        </p>
      </div>
    </div>
    <div className={styles.actions}>
      <PrimaryButton type="button" onClick={onChangePassword}>
        변경하기
      </PrimaryButton>
      <SecondaryButton onClick={onCancel}>취소하기</SecondaryButton>
    </div>
  </BottomSheet>
);

export default Credit4uPasswordExpirySheet;
